import {createStore} from 'vuex'
import {useToast} from "vue-toastification";

const toast = useToast();
export default createStore({
    state: {
        listCard: [],
        total: 0,
        status: false,
        tracking_code: "",
        list: [],
        statusType: "",
        stepLogin: 'step2',
        phone_number: ""
    },
    mutations: {

        pushProductToCart(state, payload) {
            toast.success("! به سبد اضافه شد", {
                position: "top-center",
            });
            if (state.listCard) {
                state.listCard.push({
                    'id': Math.floor(Math.random() * 5000),
                    'ids': payload.id + '_' + Math.floor(Math.random() * 8000),
                    'title': payload.title,
                    'price': payload.price,
                    'buyCredit': payload.buyCredit,
                    'git_online': payload.git_online,
                    "count": 1
                });
                localStorage.setItem("basketCart", JSON.stringify(state?.listCard));

                state.total = parseInt(state.total) + parseInt(payload.price);
                localStorage.setItem('total', state.total);
                return true;
            }
            if (localStorage.getItem("basketCart")) {
                state.listCard = JSON.parse(localStorage.getItem("basketCart"));
                state.total = localStorage.getItem('total');
                return true;
            } else {
                if (!Array.isArray(state.listCard)) {
                    state.listCard = [];
                }
                state.listCard.push({
                    'ids': payload.id + '_' + Math.floor(Math.random() * 8000),
                    'title': payload.title,
                    'price': payload.price,
                    'buyCredit': payload.buyCredit,
                    'git_online': payload.git_online,
                    "count": 1
                });
                state.total = payload.price;
                localStorage.setItem("basketCart", JSON.stringify(state?.listCard));
                localStorage.setItem('total', state.total);
            }
        },

        getCart(state) {
            return state.listCard = JSON.parse(localStorage.getItem("basketCart"));
        },
        getTotalCar(state) {
            return state.total = state.total = localStorage.getItem('total');
        },
        removeProductToCart(state, payload) {
            state.total = parseInt(localStorage.getItem('total')) - parseInt(payload.price);

            state.listCard = state.listCard.filter(item => item.id !== payload.id);

            localStorage.setItem("basketCart", JSON.stringify(state.listCard));
            localStorage.setItem("total", state.total);
            toast.success("! حذف با موفقیت انجام شده", {
                position: "top-center",
            });
        },
        statusProduct(state, payload) {
            return state.status = payload.status;
        },
        tracking(state, payload) {
            return state.tracking_code = payload.tracking_code
        },
        clearAll(state, payload) {
            localStorage.removeItem('basketCart');
            localStorage.removeItem('total');

            state.total = 0
            state.listCard = [];
            state.status = false;
            state.statusType = ""
        },
        statusType(state, payload) {
            return state.statusType = payload.status;
        },
        loginActionsStep(state, payload) {
             state.phone_number = payload.phone_number;
             state.stepLogin = payload.status;
        }


    },
    getters: {},
    actions: {
        addToCart(context, payload) {
            context.commit('pushProductToCart', payload)
        },
        removeCart(context, payload) {
            context.commit('removeProductToCart', payload)
        },
        statusStep(context, payload) {
            context.commit('statusProduct', payload)
        },
        getCart(context, payload) {
            context.commit('getCart')
        },
        getTotalCar(context, payload) {
            context.commit('getTotalCar')
        },
        statusType(context, payload) {
            context.commit('statusType', payload)
        },
        clearAll(context, payload) {
            context.commit('clearAll')
        },
        navigation(context, payload) {
            context.commit('navigation')
        },
        loginActionsStep(context, payload) {
            context.commit('loginActionsStep', payload)
        }


    },
    modules: {}
})
